import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { Processing } from 'react-wot-bootstrap'

import { CLAN_LANDING } from 'urls'

import { requestLeaderboards, getRewards } from 'state/actions/wgcwx_leaderboards'
import { openExternalBrowserWithAuth } from 'helpers/web_to_client'

import { getDatePeriod } from 'helpers/datetime'
import { LEADERBOARDS_HASH } from './constants'

import RatingCard from './components/RatingCard/RatingCard'
import Header from './components/Header/Header'
import Error from './components/Error/Error'
import Footer from './components/Footer/Footer'

import {
    LEADERBOARDS_TITLE,
    LEADERBOARDS_INFO,
    GO_TO_GLOBAL_MAP_RATINGS,
    GO_TO_GLOBAL_MAP_REWARDS,
    LEADERBOARDS_AFFIRMATIVE,
} from './translations'

import { playEnterClansBattlesGlobalMapSound, playExitClansBattlesGlobalMapSound } from 'state/actions/sounds'

import styles from './WGCWXLeaderboards.scss'

export class WGCWXLeaderboards extends React.Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        isRewardsProcessing: PropTypes.bool.isRequired,
        isRewardsTaken: PropTypes.bool.isRequired,
        leaderboards: PropTypes.object,
        requestLeaderboards: PropTypes.func.isRequired,
        getRewards: PropTypes.func.isRequired,
        globalMapUrl: PropTypes.string.isRequired,
        signInTokenUrl: PropTypes.string.isRequired,
        error: PropTypes.string,
        errorActionType: PropTypes.string,
        onClose: PropTypes.func.isRequired,
        playEnterClansBattlesGlobalMapSound: PropTypes.func.isRequired,
        playExitClansBattlesGlobalMapSound: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.playEnterClansBattlesGlobalMapSound()
        window.onBeforeUnloadHandlers.playShopSoundsOnExit = () => {
            this.props.playExitClansBattlesGlobalMapSound()
        }

        this.props.requestLeaderboards()
    }

    componentWillUnmount() {
        this.props.playExitClansBattlesGlobalMapSound()
        delete window.onBeforeUnloadHandlers.playShopSoundsOnExit
    }

    openRatingLink = (e) => {
        e.preventDefault()
        const { signInTokenUrl, globalMapUrl } = this.props
        const url = new URL(globalMapUrl)
        openExternalBrowserWithAuth(signInTokenUrl, url.origin + url.pathname + LEADERBOARDS_HASH, true)
    }

    openAboutRewardingLink = (e) => {
        e.preventDefault()
        const { signInTokenUrl, leaderboards } = this.props
        openExternalBrowserWithAuth(signInTokenUrl, leaderboards.event.aboutRewardingLink, true)
    }

    render() {
        const {
            leaderboards,
            isLoading,
            error,
            errorActionType,
            onClose,
            getRewards,
            isRewardsTaken,
            isRewardsProcessing,
        } = this.props

        if (error) {
            return (
                <Error
                    error={error}
                    errorActionType={errorActionType}
                    caption={LEADERBOARDS_AFFIRMATIVE}
                    onClose={() => onClose()}
                />
            )
        }

        if (isLoading) return (
            <Processing
                type='local'
                isVisible
            />
        )

        return (
            <div className={styles.base}>
                <div className={styles.container}>
                    <Header
                        title={LEADERBOARDS_TITLE}
                        eventName={leaderboards.event.name}
                        date={getDatePeriod(leaderboards.event.startDate, leaderboards.event.endDate)}
                    />
                    <div className={styles.infoContainer}>
                        <div className={styles.info}>
                            {LEADERBOARDS_INFO}
                        </div>
                        <div className={styles.linksBlock}>
                            <div className={styles.externalLink} onClick={this.openRatingLink}>
                                {GO_TO_GLOBAL_MAP_RATINGS}
                            </div>
                            <div className={styles.externalLink} onClick={this.openAboutRewardingLink}>
                                {GO_TO_GLOBAL_MAP_REWARDS}
                            </div>
                        </div>
                    </div>
                    <div className={styles.boardsHolder}>
                        <div className={styles.boards}>
                            {leaderboards.leaderboards.map(item => (
                                <div className={styles.boardItem} key={item.type}>
                                    <RatingCard
                                        {...item}
                                        event={leaderboards.event}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <Footer
                    reward={leaderboards.rewards}
                    getRewards={getRewards}
                    isRewardsTaken={isRewardsTaken}
                    isRewardsProcessing={isRewardsProcessing}
                />
            </div>
        )
    }
}
export const stateToProps = ({ settings, wgcwxLeaderboards, wgcwxClanInfo }) => {
    const clanId = wgcwxClanInfo.clan_info && wgcwxClanInfo.clan_info.id
    return {
        clanChannelId: clanId && `gm_clan_${clanId}`,
        globalMapUrl: settings.globalMapUrl,
        signInTokenUrl: settings.signInTokenUrl,
        isLoading: wgcwxLeaderboards.isLoading,
        isRewardsProcessing: wgcwxLeaderboards.isRewardsProcessing,
        isRewardsTaken: wgcwxLeaderboards.isRewardsTaken,
        error: wgcwxLeaderboards.errorMessage,
        errorActionType: wgcwxLeaderboards.errorActionType,
        leaderboards: wgcwxLeaderboards.leaderboards,
    }
}

const dispatchToProps = (dispatch) => ({
    requestLeaderboards: () => dispatch(requestLeaderboards()),
    getRewards: () => dispatch(getRewards()),
    onClose: () => dispatch(push(CLAN_LANDING)),
    playEnterClansBattlesGlobalMapSound: () => dispatch(playEnterClansBattlesGlobalMapSound()),
    playExitClansBattlesGlobalMapSound: () => dispatch(playExitClansBattlesGlobalMapSound()),
})

export default connect(stateToProps, dispatchToProps)(WGCWXLeaderboards)



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/WGCWXLeaderboards.jsx